import { toast } from 'react-toastify'

interface IUseToast {
	type: 'success' | 'error' | 'info' | 'warning'
	message: string | any
}

export const useToast = ({ type, message }: IUseToast) => {
	return () => toast[type](message)
}
